import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin'

import App from './App.vue'
import router from './router'
import store from './store'
// Theme Configurations
import '../themeConfig.js'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import numeral from 'numeral'
 
Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  const noop = () => {}
  console.log = noop
  console.info = noop
  console.debug = noop
  console.warn = noop
}

import AudioVisual from 'vue-audio-visual'
Vue.use(AudioVisual)
Vue.use(Vuesax)

Vue.prototype.$EventBus = new Vue()
// Globally Registered Components

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)
 

 
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Filters
import './filters/filters.js'


// Tailwind
import '@/assets/css/main.css'

// i18n
import i18n from './i18n/i18n'

import {flatten,unflatten} from 'flat'

import { format } from 'date-fns'
import { Number } from 'core-js'

Vue.use(flatten);
Vue.use(unflatten);
Vue.use(DashboardPlugin)
Vue.use(VueRouter)
Vue.use(RouterPrefetch)


Vue.prototype.dateLang = (param) => {
  return ko 
}


Vue.prototype.alert = (param) => {
  app.$modal.show('alert',{
    ...param
  })
}

Vue.prototype.confirm = (param) => {
  app.$modal.show('alertConfirm',{
    ...param
  })
}
Vue.prototype.openModal = (id) => {
  app.$modal.show(id,{ scrollable: true })
}

Vue.prototype.closeModal = (id) => {
  app.$modal.hide(id)
}
Vue.prototype.closeAllModal = (id) => {
  app.$modal.hideAll()
}

Vue.prototype.loadingShow = (id) => {
  app.$vs.loading()
}
Vue.prototype.loadingHide = (id) => {
  app.$vs.loading.close()
}
Vue.prototype.valCheck = (val) => {
  if(val == '' || val == null || val == "Invalid date"){
    return true
  }else{
    return false
  }
}
Vue.prototype.numberFilter = (val) => {
  if(val == '' || val == null){
    return 0
  }else{
    let num = String(val).replace(/,/gi, ""); 
    return Number(num)
  }
}
Vue.prototype.noti = (val,color) => {

  app.$vs.notify({text:val,position:'top-center', color:color ? color : 'primary' })
}

// datepicker용 selected 값 포맷
Vue.prototype.fixDate = (event,formatVal) => {
  if(!event || event == '' || event == null || event == undefined) {
    return null;
  }
  let data = new Date(event)
  if(formatVal){
    return format(data,formatVal);
  }else{
    
    return format(data,'yyyy-MM-dd');
  }
  
}
Vue.prototype.moment = (data) => {
  return moment(data)
}

Vue.prototype.historyBack = (val) => {
  app.$router.go(-1)
}
Vue.prototype.getExcelFileDown =(response) =>{
  let filename = "",
      disposition = response.headers["content-disposition"];
    
  if (disposition && disposition.indexOf("attachment") !== -1) {
      let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
      }
  }

  if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
      window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
          filename);
  } else {
      const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
  }
}

//file upload 
Vue.prototype.inputFilter = (newFile, oldFile, prevent) => {
  if (newFile && !oldFile) {
    
    // Before adding a file
    // 添加文件前
    // Filter system files or hide files
    // 过滤系统文件 和隐藏文件
    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
      return prevent()
    }
    // Filter php html js file
    // 过滤 php html js 文件
    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
      return prevent()
    }
  }
}
Vue.prototype.onlyNumber = (data) => {
  if (!data) return 0
  let num = String(data).replace(/\,/g,'')
  return Number(num)
}
Vue.prototype.numberFormat = (data,dd) => {
  if (!data) return 0
  let decimal = '0,0'
  let num = String(data).replace(/\,/g,'')
  num = Number(num)
  if(dd){
    num  = Math.floor(data * 10000) / 10000 
    
    if(dd == 0 ){
      num  = Math.floor(num)
      decimal = '0,0'
    }else{
      decimal = '0,0.00'
    }
    return numeral(num).format(decimal) ;
  }else{
    num  = Math.floor(data * 10000) / 10000 
    num = +parseFloat(num).toFixed(4)
    let dd ;
    if(num % 1 === 0){
      dd = numeral(num).format("0,0") ;  
    }else{
      dd = numeral(num).format("0,0.00") ;
    }
    
    return dd
  }
  
}
Vue.prototype.numberFormatAll = (data) => {
  if(typeof data != Number){
    //str.replace(/\-/g,'');
  }
  if (!data || data == '' || data == 'NaN' || data == 'Infinity') return 0
  let val = numeral(data).format("0,0[.][00000000000000]") ;
  
  return val
}

Vue.prototype.inputFile = (newFile, oldFile) => {
  if (newFile && !oldFile) {
    // add
    console.log('add', newFile)
  }
  if (newFile && oldFile) {
    // update
    console.log('update', newFile)
  }
  if (!newFile && oldFile) {
    // remove
    console.log('remove', oldFile)
  }
}
Vue.prototype.parse = (data) => {
  if (!data || data=='') return 0
  console.log(data)
  const ddd = data.replace(/,/g, '');
  console.log('ddd',ddd)
  return ddd
}
Vue.prototype.processDataFromClipboard = (params) => {
  console.log(params)
}
Vue.prototype.tableColdef = () => {
  
  return {
    
    suppressMenu: false,
    rowSelection:'row',
    suppressRowTransform : true,
    suppressKeyboardEvent: false,
    suppressHeaderKeyboardEvent: false,
    sortable: false,
    editable: false,
    resizable: true,
  }
}
Vue.prototype.tableGridOption = () => {
  return {
      context: {
          componentParent: app
      },
      onGridReady: function (event) {
      },
      onRowClicked: (event)=>{
          app.viewDetail(event)
      },
      frameworkComponents : {
          btnSelect : BtnSelect,
          textRender : TextRender
      },
      getRowHeight:(params)=>{
          console.log(params)
          return 100;
      }
  }
}


//datepikcer  disabled start end date set
Vue.prototype.startDisabled = (date, edata) => {
  console.log(edata)
  if( edata ){
    let date = new Date(edata)
    date.setHours(0, 0, 0, 0);
    return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
  }else{
    return true
  }
 
  return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
}
Vue.prototype.endDisabled = (sdata,edata) => {
  if (!edata) return 0
  let num = String(data).replace(/\,/g,'')
  return true
}

import {language,country, roles,instruments} from '@/optionData/data.js'
Vue.prototype.parse = (data) => {
  if (!data || data=='') return 0
  console.log(data)
  const ddd = data.replace(/,/g, '');
  console.log('ddd',ddd)
  return ddd
}
Vue.prototype.transRole = (data) => {
    if(!data) return '-'
    const result = roles.find((item) => item.value == data)
    return result ? result.label_ko : data
}
Vue.prototype.transInstrument = (data) => {
    if(!data) return '-'
    const result = instruments.find((item) => item.value == data)
    return result ? result.label_ko : data
}    


const app = new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')

export default app 
